import React from 'react';
import { experienceData } from '../../../data/experienceData';
import Reveal from '../../helper/reveal';
import ExperienceCard from './experience-card';
import Timeline from './timeline';
import './experience.css';

function Experience() {
    return (
        <section className='section experience' id='experience' aria-labelledby='experience-title'>
            <div className='container'>
                <Reveal className='section-head'>
                    <span className='eyebrow'>02 / Experience</span>
                    <h2 id='experience-title' className='section-title'>Where I've worked.</h2>
                </Reveal>

                <Reveal>
                    <Timeline />
                </Reveal>

                <ol className='experience__list'>
                    {experienceData.map((job, index) => (
                        <Reveal as='li' key={job.id} delay={index * 70} className='experience__item'>
                            <ExperienceCard job={job} />
                        </Reveal>
                    ))}
                </ol>
            </div>
        </section>
    );
}

export default Experience;
